/*
@phone        : принимаемое значение телефона на данный момент
@phoneCode    : код страны, для которой применяется маска той самой страны (например, для России это будет +7)
@countryCode  : код страны в тектовом значении (для России RU)
*/

export const sanitizePhone = (phone, phoneCode = '+7', countryCode = 'RU') => {
  let sanitizedPhone = phone;

  // Условие для России (RU): если номер начинается с +7
  if (sanitizedPhone && sanitizedPhone.startsWith(phoneCode) && countryCode === 'RU') {
    sanitizedPhone = sanitizedPhone.substring(2);
  }

  // Условие для Узбекистана (UZ): если номер начинается с +998
  if (sanitizedPhone && sanitizedPhone.startsWith(phoneCode) && countryCode === 'UZ') {
    sanitizedPhone = sanitizedPhone.substring(4);
  }

  return sanitizedPhone
}